<mat-toolbar class="top-bar">
  <div class="toolbar-content">
    <div class="left-section">
      <div class="logo-block">
        <img src="logo.png" alt="Wide & Heavy Logo" class="logo" matTooltip="Wide & Heavy" />

        <span class="app-title">
          {{ isMobile ? pageTitle : 'Admin Panel' }}
        </span>
      </div>
    </div>

    <div class="right-section">

      <button mat-icon-button (click)="goBack()" matTooltip="Back">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <button mat-button (click)="logout()">
        <mat-icon>logout</mat-icon>
        Log Out
      </button>

    </div>
  </div>
</mat-toolbar>